/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { GlideCarousel } from "../../components/atoms/glide";
import classNames from "classnames";
import get from "lodash/get";
import { ResponsiveHeroImage, ReviewRating, LazyLoadImages } from "@quintype/components";
import { CustomLink } from "../custom-link";
import { AdService } from "../ad-service";
import { ImageFallback } from "../basic/image-fallback.js";
import { isExternalStory, getStoryUrl } from "../../utils";
import { breakpoint } from "../../../utils/breakpoint";
import PropTypes from "prop-types";

function OneMainCardSlider(props) {
  let resizeDone = false;

  const resize = () => {
    if (resizeDone === false) {
      global.dispatchEvent(new global.Event("resize"));
      resizeDone = true;
    }
  };

  const mobileOptions = {
    afterSlide: resize,
    perView: 1,
    arrow: true,
    dot: "",
    autoplay: 5000,
    gap: 7,
    peek: {
      before: "27px",
      after: "27px"
    },
    rtl: get(props.config, ["theme-attributes", "language_direction"]) === "right"
  };

  const desktopOptions = {
    afterSlide: resize,
    perView: 1,
    arrow: true,
    dot: "",
    gap: 30,
    autoplay: 5000,
    peek: {
      before: "270px",
      after: "270px"
    },
    rtl: get(props.config, ["theme-attributes", "language_direction"]) === "right"
  };

  const sliderDefaultSettings = breakpoint("tablet") ? { ...mobileOptions } : { ...desktopOptions };

  const storyData = get(props, ["stories"], []);
  const stories = storyData.slice(0, 5);
  return stories && stories.length < 3 ? null : (
    <div className="one-main-card-slider component-wrapper-fluid">
      <div className="component-wrapper">
        <GlideCarousel {...sliderDefaultSettings} className="one-main-card-slider__slides">
          {stories.map(item => (
            <div key={item.id} className="one-main-card-slider__slider-content">
              <SliderItem item={item} languageDirection={props.languageDirection} />
            </div>
          ))}
        </GlideCarousel>
      </div>
      <div className="app-ad app-ad--horizontal">
        <AdService
          adtype="Horizontal-Ad"
          layoutName="OneMainCardSlider"
          collectionSlug={props.config["collection-slug"]}
          slotId={`LShapeOneWidget-${props.index}`}
        />
      </div>
    </div>
  );
}
OneMainCardSlider.propTypes = {
  config: PropTypes.object,
  stories: PropTypes.array,
  languageDirection: PropTypes.string,
  index: PropTypes.number
};

function SliderItem(props) {
  /* The `story` can be an item from items of a collection or a story itself.
   assigning it accordinlgy. */
  const story = props.item.type === "story" && props.item.story ? props.item.story : props.item;
  const isReviewStory = story["story-template"] === "review";
  return (
    <CustomLink
      className={classNames("overlay-story-card", { "overlay-story-card--video": story["story-template"] === "video" })}
      externalLink={isExternalStory(story)}
      href={"" + getStoryUrl(story)}
    >
      {story["hero-image-s3-key"] ? (
        <figure>
          <LazyLoadImages>
            <ResponsiveHeroImage
              story={story}
              aspectRatio={[57, 32]}
              defaultWidth={320}
              widths={[250, 480, 640]}
              imgParams={{ auto: ["format", "compress"], fit: "max" }}
            />
          </LazyLoadImages>
        </figure>
      ) : (
        <ImageFallback story={story} />
      )}
      {isReviewStory && <ReviewRating value={get(story, ["metadata", "review-rating", "value"], "0")} />}
      <p
        className={`overlay-story-card__heading ${props.languageDirection === "right" ? "content-right" : ""}`}
        dangerouslySetInnerHTML={{ __html: story.headline }}
      />
    </CustomLink>
  );
}
SliderItem.propTypes = {
  item: PropTypes.object,
  languageDirection: PropTypes.string
};

export { OneMainCardSlider };
